"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.unifiedNumberFormat = unifiedNumberFormat;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _intlUnifiedNumberformat = require("@formatjs/intl-unified-numberformat");
var _locale = require("../const/locale");
var _excluded = ["value"];
_intlUnifiedNumberformat.UnifiedNumberFormat.__addLocaleData(require('@formatjs/intl-unified-numberformat/dist/locale-data/en.json') // locale-data for en
);
function unifiedNumberFormat(_ref /*:: */) {
  var value = _ref /*:: */.value,
    options = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  return new _intlUnifiedNumberformat.UnifiedNumberFormat(_locale.LOCALE, options).format(value);
}
var _default = exports.default = unifiedNumberFormat;
//# sourceMappingURL=unifiedNumberFormat.js.map